@if (!data.headerMessage) {
  <h2 mat-dialog-title>There has been an error completing this request.</h2>
}
@if (data.headerMessage) {
  <h2 mat-dialog-title [innerHTML]="data.headerMessage"></h2>
}

<mat-dialog-content>
  @for (errMsg of data.errorMessages; track errMsg) {
    <p [innerHTML]="errMsg.description || errMsg.message || errMsg"></p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <app-button (click)="onClose()" [label]="'Close'" [color]="'primary'"></app-button>
</mat-dialog-actions>
